import Loadable from "app/components/Loadable";
import { lazy } from "react";

const MarketingOfficerWiseFarmVisitList = Loadable(
  lazy(() => import("./MarketingOfficerWiseFarmVisitList"))
);

const marketingOfficerWiseFarmVisitRoutes = [
  {
    path: "/MarketingOfficerWiseFarmVisit/MarketingOfficerWiseFarmVisitList",
    element: <MarketingOfficerWiseFarmVisitList />,
  },
];
export default marketingOfficerWiseFarmVisitRoutes;
